/**
 * Shell constants (design/ui/design_handoff_navigation_shell).
 * The product name is one constant, so a rename is one edit; the rail's hover
 * behaviour is one constant because the handoff ships both modes and wants the
 * other to stay a config flip, not a fork.
 */

/** 'expand' — the rail widens to 232px on hover/focus. 'tooltips' — it stays 64px. */
export type RailMode = 'expand' | 'tooltips'

/** Renamed from 'Cortex' on 19 Aug 2026. 'Cortex' stays the repository name. */
export const PRODUCT_NAME = 'Therion Analytics'
export const RAIL_MODE: RailMode = 'expand'
export const RAIL_CLOSED = 64
export const RAIL_OPEN = 232

/** The workspace the rail's footer names — Kaleidex Group (Kirkstall + Oracle). */
export const WORKSPACE = { name: 'Kaleidex Group', initials: 'KG' }

/** Global search is designed but not built; the markup stays behind this flag. */
export const SHOW_SEARCH: boolean = false
